/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_FalseInputs */

const en_common_false = /** @type {(inputs: Common_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`false`)
};

const fr_common_false = /** @type {(inputs: Common_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`faux`)
};

const de_common_false = /** @type {(inputs: Common_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FALSCH`)
};

const it_common_false = /** @type {(inputs: Common_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`falso`)
};

const ru_common_false = /** @type {(inputs: Common_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЛОЖЬ`)
};

const es_common_false = /** @type {(inputs: Common_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FALSO`)
};

const zh_cn2_common_false = /** @type {(inputs: Common_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误的`)
};

const ja_common_false = /** @type {(inputs: Common_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間違い`)
};

const hi_common_false = /** @type {(inputs: Common_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असत्य`)
};

const pt_pt2_common_false = /** @type {(inputs: Common_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`falso`)
};

/**
* | output |
* | --- |
* | "false" |
*
* @param {Common_FalseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_false = /** @type {((inputs?: Common_FalseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_FalseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_common_false(inputs)
	if (locale === "de") return de_common_false(inputs)
	if (locale === "it") return it_common_false(inputs)
	if (locale === "ru") return ru_common_false(inputs)
	if (locale === "es") return es_common_false(inputs)
	if (locale === "zh-CN") return zh_cn2_common_false(inputs)
	if (locale === "ja") return ja_common_false(inputs)
	if (locale === "hi") return hi_common_false(inputs)
	if (locale === "pt-PT") return pt_pt2_common_false(inputs)
	return en_common_false(inputs)
});